<template>
  <form class="document-search" @keyup.esc="onSearchClose" @submit.prevent>
    <input
      v-model.trim="query"
      type="text"
      class="document-search__input"
      autofocus
      @keypress.enter="onSearchInput"
    />
    <span class="document-search__counter">{{ counterText }}</span>
    <button
      class="document-search__button _up"
      type="button"
      :disabled="moveButtonsDisabled"
      @click="onSearchAnother('prev')"
    >
      <svg width="20" height="20">
        <use xlink:href="#chevron" />
      </svg>
    </button>
    <button
      class="document-search__button _down"
      type="button"
      :disabled="moveButtonsDisabled"
      @click="onSearchAnother('next')"
    >
      <svg width="20" height="20">
        <use xlink:href="#chevron" />
      </svg>
    </button>
    <button
      class="document-search__button _close"
      type="button"
      @click="onSearchClose"
    >
      <svg width="20" height="20">
        <use xlink:href="#cross" />
      </svg>
    </button>
  </form>
</template>

<script>
import apiDocuments from '@src/api/documents';

import { mapGetters } from 'vuex';

export default {
  props: {
    currentView: {
      type: String,
      required: true
    }
  },

  data: () => ({
    query: ''
  }),

  watch: {
    currentView: function() {
      this.query = ''
    }
  },

  computed: {
    ...mapGetters([
      'searchMatchesCount',
      'currentSearchMatch'
    ]),
    counterText() {
      let str = '';
       str = (this.searchMatchesCount !== null)? 
        `${this.currentSearchMatch}/${this.searchMatchesCount}`:''  

      return str
    },
    moveButtonsDisabled() {
      return this.searchMatchesCount < 2 && this.currentSearchMatch === 1; 
    }
  },

  beforeDestroy() {
    this.$store.dispatch('cleanSearchData');
  },

  methods: {
    onSearchInput() {
      if(this.currentView === 'html') {
        this.$store.dispatch('getMatchesForHtml', this.query);
      }
      if(this.currentView === 'scan') {
        this.$store.dispatch('getMatchesForScan', this.query);
      }
    },
    onSearchClose() {
      this.$store.dispatch('cleanSearchData');
      this.$emit('searchClose');
    },
    onSearchAnother(direction) {
      this.$store.dispatch('scrollToAnotherFoundMatch', direction);
    }
  }
};
</script>
